import Onboarding from '@pages/Onboarding';

export const ONBOARDING_ROUTES = [
  {
    index: true,
    element: <Onboarding.Profile />,
  },
];
